import { render, staticRenderFns } from "./free-item-product-list.vue?vue&type=template&id=588d2dee&scoped=true&"
import script from "./free-item-product-list.vue?vue&type=script&lang=js&"
export * from "./free-item-product-list.vue?vue&type=script&lang=js&"
import style0 from "./free-item-product-list.vue?vue&type=style&index=0&id=588d2dee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588d2dee",
  null
  
)

export default component.exports